import { connect } from "react-redux";
import { Dispatch } from "redux";
import { closeSubModal, CloseSubModalAction } from "src/store/actions/onlineShopper/subModal";
import Modal from "../components/Modal";
import { ApplicationStore } from "../store";

export function mapStateToProps({ onlineShopper }: ApplicationStore) {
    const subModal = onlineShopper.subModal || {};
    return {
        modalType: subModal.type,
        open: subModal.isOpen || false,
    };
}

export function mapDispatchToProps(dispatch: Dispatch<CloseSubModalAction>) {
    return {
        closeModal: () => dispatch(closeSubModal()),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Modal);
